import type { Asset2ReviewStatus } from '../../../../../../../../../../apis/graphql';
import { adStatuses, reviews } from '../../../../../../../../../../configs';
import { isAdActivationForbidden } from '../../../../../../../../../../utils/ad';
import type { AdEntity } from '../../../../../../types';
import { AD_STATUS_CONFLICT_MESSAGE, AD_STATUS_NO_ACCEPTED_CREATIVE_CONFLICT } from '../../getRows/constants';

type Props = {
  entities: Array<AdEntity>;
  isSectionSelected: boolean;
  creativeStatusMap: Record<string, Asset2ReviewStatus | null>;
};

export const checkStatusAdsConflicts = ({
  entities,
  isSectionSelected,
  creativeStatusMap,
}: Props): Record<string, string[]> | null => {
  if (!isSectionSelected) {
    return null;
  }

  const errors: Record<string, string[]> = {};

  entities.forEach((entity) => {
    const { status, review, id } = entity;

    if (review !== reviews.APPROVED && status === adStatuses.ON) {
      errors[AD_STATUS_CONFLICT_MESSAGE] = errors[AD_STATUS_CONFLICT_MESSAGE]
        ? [...errors[AD_STATUS_CONFLICT_MESSAGE], id]
        : [id];
    }

    if (
      status === adStatuses.ON &&
      isAdActivationForbidden({
        ad: entity,
        creativeReview: creativeStatusMap[entity.id],
      })
    ) {
      errors[AD_STATUS_NO_ACCEPTED_CREATIVE_CONFLICT] = errors[AD_STATUS_NO_ACCEPTED_CREATIVE_CONFLICT]
        ? [...errors[AD_STATUS_NO_ACCEPTED_CREATIVE_CONFLICT], id]
        : [id];
    }
  });

  return Object.keys(errors).length ? errors : null;
};
